// Central environment helpers
// Works with Vite (import.meta.env) and falls back to process.env
const viteEnv: any = import.meta.env;

export const appMode: string | undefined = viteEnv.MODE;
export const isDev: boolean = !!viteEnv.DEV;
export const isProd: boolean = !!viteEnv.PROD;

export const nodeEnv: string = (
  typeof process !== 'undefined' && process.env.NODE_ENV
    ? process.env.NODE_ENV
    : appMode || (isDev ? 'development' : 'production')
).toLowerCase();

export const isStaging = appMode === 'staging' || nodeEnv === 'staging';
export const isLocalDev = appMode === 'localDev' || (isDev && !isStaging);

export function seThemeBaseUrl(base: string): string {
  if (!base) return base;
  if (appMode === 'staging' && isDev) {
    return base.replace('dlthemes', 'mlthemes');
  }
  if (appMode === 'production' && isDev) {
    return base.replace('dlthemes', 'themes');
  }
  if (appMode === 'production') {
    return base.replace('dlthemes', 'themes');
  }
  return base;
}

export function setApiBaseUrl(base: string): string {
  if (!base) return base;
  if (appMode === 'development' && isDev) {
    return base.replace('api', 'dlapi');
  }
  if (appMode === 'staging' && isDev) {
    return base.replace('api', 'mlapi');
  }
  return base;
}

export default {
  appMode,
  nodeEnv,
  isDev,
  isProd,
  isStaging,
  isLocalDev,
  seThemeBaseUrl,
  setApiBaseUrl,
};
